export const EM310List: any[] = [
  {
    deviceName: 'UDS-6632',
    payload: null
  },
  {
    deviceName: 'UDS-7097',
    payload: null
  },
  {
    deviceName: 'UDS-7999',
    payload: null
  },
  {
    deviceName: 'UDS-8479',
    payload: null
  },
  {
    deviceName: 'UDS-8653',
    payload: null
  },
  {
    deviceName: 'UDS-9228',
    payload: null
  },
  {
    deviceName: 'UDS-9340',
    payload: null
  },
  {
    deviceName: 'UDS-9510',
    payload: null
  },
  {
    deviceName: 'UDS-9929',
    payload: null
  }
]